import { jsx as _jsx } from "react/jsx-runtime";
import { getAdminMenuItems } from "@apptypes/adminMenuItems";
import { useAppInitialization } from "@hooks/useAppInitialization";
import { useNavigate } from "react-router-dom";
import BaseLayout from "./BaseLayout";
import CommonLayout from "./CommonLayout";
var AdminLayout = function () {
    /**
     * Custom hook for application initialization (fetching user data, menu, etc.).
     * @type {object}
     * @property {boolean} loading - Indicates if app initialization is in progress.
     * @property {() => Promise<void>} handleLogout - Function to handle user logout.
     */
    var handleLogout = useAppInitialization().handleLogout;
    var navigate = useNavigate();
    var menuItems = getAdminMenuItems(navigate);
    return (_jsx(BaseLayout, { handleLogout: handleLogout, children: _jsx(CommonLayout, { menuItems: menuItems }) }));
};
export default AdminLayout;
